<ng-template #defaultConfirmationTitle>
    <h3 mat-dialog-title>
        {{ data.title }}
        <button mat-icon-button [disableRipple]="true" mat-dialog-close><mat-icon>close</mat-icon></button>
    </h3>
</ng-template>

<div *ngIf="data.titleIcon; else defaultConfirmationTitle" mat-dialog-title>
    <app-avatar-block [size]="data.largeTitleIcon ? 'xl': 'lg'" [svgIcon]="data.titleIcon" [wrappedText]="true">
        <h3 avatarTitle>{{ data.title }}</h3>
        <p *ngIf="data.content" [innerHTML]="data.content" avatarDescription></p>
    </app-avatar-block>
    <button mat-icon-button [disableRipple]="true" mat-dialog-close><mat-icon>close</mat-icon></button>
</div>

<mat-dialog-content *ngIf="data.titleIcon && data.danger">
    <p class="confirmation-warning" [innerHTML]="data.danger"></p>
</mat-dialog-content>

<ng-template #baseContent>
    <p *ngIf="data.content" [innerHTML]="data.content"></p>
    <p *ngIf="data.danger" class="confirmation-warning" [innerHTML]="data.danger"></p>
</ng-template>

<mat-dialog-content *ngIf="!data.titleIcon">
    <form *ngIf="data.control; else baseContent" [formGroup]="formGroup">
        <ng-container *ngTemplateOutlet="baseContent"></ng-container>
        <div class="form-group">
            <mat-slide-toggle *ngIf="data.control.type === 'toggle'" [formControlName]="data.control.type">
                {{ data.control.label }}
            </mat-slide-toggle>
            <label *ngIf="data.control.type !== 'toggle'">{{ data.control.label }}</label>
            <mat-form-field *ngIf="data.control.type === 'select'" appearance="outline" subscriptSizing="dynamic">
                <mat-select [panelClass]="'v2-panel'" placeholder="{{ 'Select Option' }}" [formControlName]="data.control.type">
                    <mat-option *ngFor="let option of data.control.options; trackBy: trackByValue"
                                [value]="option">
                        {{ option.label }}
                        <span *ngIf="option.subtitle" class="option-subtitle">{{ option.subtitle }}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <lf-control-messages [control]="formGroup.get(data.control.type)"></lf-control-messages>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-flat-button [disableRipple]="true" color="accent"
            [class.hidden]="data.hideCancelButton"
            (click)="closeAndCancel()">
        {{ data.cancelButton || 'Cancel' }}
    </button>

    <!-- Cancel is not a peer of the two that act, so it keeps the left edge. -->
    <flex-spacer *ngIf="!data.hideCancelButton && data.secondaryButton"></flex-spacer>
    <button-spacer *ngIf="!data.hideCancelButton && !data.secondaryButton"></button-spacer>

    <button *ngIf="data.secondaryButton"
            mat-flat-button [disableRipple]="true" color="accent"
            (click)="closeSecondary()">
        {{ data.secondaryButton }}
    </button>
    <button-spacer class="sm" *ngIf="data.secondaryButton"></button-spacer>

    <button mat-flat-button [disableRipple]="true" color="primary"
            (click)="closeAndConfirm()">
        {{ confirmButtonLabel }}
    </button>

    <flex-spacer *ngIf="data.hideCancelButton"></flex-spacer>
</mat-dialog-actions>
